import React from "react";
import { formatDateTime } from "../../../../utils/dateFormat";

export default function Card({ title, value, icon, date }) {
  return (
    <div
      className="p-3 d-flex flex-column gap-3 rounded bg-light fw-medium"
      style={{ minWidth: "15rem" }}
    >
      <p className="m-0">{title}</p>
      <div className="d-flex gap-2 align-items-center">
        <div
          className="bg-secondary p-1 d-flex justify-content-center align-items-center"
          style={{
            width: "2rem",
            height: "2rem",
            borderRadius: "2rem",
          }}
        >
          <i class={`${icon} text-white`}></i>
        </div>
        <h4 className="m-0 text-primary fw-bold">{value}</h4>
      </div>
      <p
        className="m-0"
        style={{ alignSelf: "end", fontSize: ".7rem", opacity: 0.8 }}
      >
        as of {formatDateTime(date)}
      </p>
    </div>
  );
}
